import { render, staticRenderFns } from "./CategoryEditor.vue?vue&type=template&id=123048ac&scoped=true&"
import script from "./CategoryEditor.vue?vue&type=script&lang=js&"
export * from "./CategoryEditor.vue?vue&type=script&lang=js&"
import style0 from "./CategoryEditor.vue?vue&type=style&index=0&id=123048ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123048ac",
  null
  
)

export default component.exports